import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import React from 'react';
import useAuthToken from '../../../hooks/getUserData';
import EditProductComparison from './EditProductComparison';

const ProductComparison = ({
  product,
  fetchProduct,
  setMessage,
  setSnackbarOpen,
}) => {
  const token = useAuthToken();

  return (
    <>
      {product.category_data?.category_details?.length > 0 && (
        <Card>
          <CardHeader
            title="Product comparison"
            action={
              <EditProductComparison
                product={product}
                fetchData={fetchProduct}
                token={token}
                setMessage={setMessage}
                setSnackbarOpen={setSnackbarOpen}
              />
            }
            sx={{ paddingBottom: 0 }}
          />
          <CardContent>
            {product?.category_product_relation &&
            Object.keys(product.category_product_relation).length > 0 ? (
              Object.entries(product?.category_product_relation).map(
                ([key, value]) => (
                  <Grid
                    key={key}
                    style={{
                      margin: '16px 0',
                    }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <div>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: 'bold', display: 'inline' }}>
                          {key
                            .split('_')
                            .map(
                              (a) => a?.charAt(0).toUpperCase() + a?.slice(1)
                            )
                            .join('')}{' '}
                          :{' '}
                        </Typography>
                        {value !== '' ? value : 'N/A'}
                      </div>
                    </div>
                  </Grid>
                )
              )
            ) : (
              <Typography
                sx={{ textAlign: 'center' }}
                variant="caption"
                component="p">
                You can add category product comparison data here
              </Typography>
            )}
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default ProductComparison;
